import { render, staticRenderFns } from "./grammar.vue?vue&type=template&id=35b0519e&scoped=true"
import script from "./grammar.vue?vue&type=script&lang=js"
export * from "./grammar.vue?vue&type=script&lang=js"
import style0 from "./grammar.vue?vue&type=style&index=0&id=35b0519e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0519e",
  null
  
)

export default component.exports